export default __webpack_public_path__ + "static/author1-0cdd3ed384d3d1b851f1cdb7285d539b.png";